import { userStatus } from '../../../utils/constants';
import requestStatus from './requestStatus';

export default function(status) {
  if(status === userStatus.PendingApproval) {
     return requestStatus.PendingApproval
  }
}


// WEBPACK FOOTER //
// ./src/containers/userregistration/logic/pendingRequest.js